/* Liberato store reviews — button + popup
   /pages/reviews?view=popup（中身だけの断片）を fetch して差し込みます。
   ページ側のインラインスクリプトは <script> を作り直して実行するので、
   並べ替え・絞り込み・ライトボックス・原文トグルはページ側の実装がそのまま動きます。 */
(function () {
  'use strict';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* innerHTML では <script> が実行されないので、作り直して追加する */
  function inject(container, html) {
    var doc = new DOMParser().parseFromString('<!doctype html><body>' + html + '</body>', 'text/html');
    var scripts = Array.prototype.slice.call(doc.querySelectorAll('script'));
    scripts.forEach(function (s) { if (s.parentNode) s.parentNode.removeChild(s); });

    container.innerHTML = doc.body.innerHTML;

    scripts.forEach(function (old) {
      var s = document.createElement('script');
      for (var i = 0; i < old.attributes.length; i++) {
        s.setAttribute(old.attributes[i].name, old.attributes[i].value);
      }
      if (!old.src) s.textContent = old.textContent;
      container.appendChild(s);
    });
  }

  function build(root) {
    var btn = root.querySelector('.lsr-open');
    var modal = root.querySelector('.lsr-modal');
    var body = root.querySelector('.lsr-body');
    if (!btn || !modal || !body) return;

    var lastFocus = null;
    var loaded = false;

    function open() {
      lastFocus = document.activeElement;
      modal.hidden = false;
      document.documentElement.classList.add('lsr-lock');
      var x = modal.querySelector('.lsr-close');
      if (x) x.focus();
      if (!loaded) { loaded = true; load(); }
    }

    function close() {
      modal.hidden = true;
      document.documentElement.classList.remove('lsr-lock');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    function fail() {
      loaded = false;
      body.innerHTML =
        '<p class="lsr-msg">' + esc(body.getAttribute('data-error')) + ' ' +
        '<a href="' + esc(body.getAttribute('data-fallback')) + '">' +
        esc(body.getAttribute('data-full')) + '</a></p>';
    }

    function load() {
      body.innerHTML = '<p class="lsr-msg">' + esc(body.getAttribute('data-loading')) + '</p>';
      fetch(body.getAttribute('data-src'), { credentials: 'same-origin' })
        .then(function (r) {
          if (!r.ok) throw new Error(r.status);
          return r.text();
        })
        .then(function (html) {
          inject(body, html);
          /* 表示されてから初めて幅が確定するので、レイアウトを促す */
          setTimeout(function () {
            if (typeof window.__lbrLayout === 'function') window.__lbrLayout();
            else window.dispatchEvent(new Event('resize'));
          }, 0);
        })
        .catch(fail);
    }

    btn.addEventListener('click', open);

    modal.addEventListener('click', function (e) {
      if (e.target === modal || (e.target.closest && e.target.closest('.lsr-close'))) close();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || modal.hidden) return;
      /* 写真のライトボックスが開いているときは、そちらを先に閉じさせる */
      var lb = document.getElementById('lbr-lb');
      if (lb && lb.classList.contains('on')) return;
      close();
    });
  }

  function init() {
    var nodes = document.querySelectorAll('.lsr[data-lsr]:not([data-lsr-ready])');
    Array.prototype.forEach.call(nodes, function (el) {
      el.setAttribute('data-lsr-ready', '1');
      build(el);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
